"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractEvaluationHandler = void 0;
const jsonpath_1 = __importDefault(require("jsonpath"));
const ConstraintUtils_1 = require("../../ConstraintUtils");
class AbstractEvaluationHandler {
    constructor(_client) {
        this._client = _client;
    }
    setNext(handler) {
        this.nextHandler = handler;
        return handler;
    }
    getNext() {
        return this.nextHandler;
    }
    hasNext() {
        return this.nextHandler != undefined;
    }
    get client() {
        return this._client;
    }
    get wrappedVcs() {
        return this._client.wrappedVcs;
    }
    set wrappedVcs(wrappedVcs) {
        this._client.wrappedVcs = wrappedVcs;
    }
    get presentationSubmission() {
        return this._client.presentationSubmission;
    }
    set presentationSubmission(presentationSubmission) {
        this._client.presentationSubmission = presentationSubmission;
    }
    getResults() {
        return this._client.results;
    }
    updatePresentationSubmission(pd) {
        this.presentationSubmission.descriptor_map.forEach((descriptor, index, descriptorMap) => {
            /**
               * TODO map the nested credential
               let vcPath = jp.stringify(e.payload.result.path)
               */
            let inputDescriptor;
            const result = this.getResults()
                .filter((r) => r.status === ConstraintUtils_1.Status.ERROR && r.evaluator === this.getName())
                .find((result) => {
                inputDescriptor = jsonpath_1.default.query(pd, result.input_descriptor_path)[0];
                return result.verifiable_credential_path === descriptor.path && (inputDescriptor === null || inputDescriptor === void 0 ? void 0 : inputDescriptor.id) === descriptor.id;
            });
            if (result) {
                delete descriptorMap[index];
            }
        });
    }
    removeDuplicate(results) {
        return results.reduce((arr, cur) => {
            const result = arr.find((i) => i.input_descriptor_path === cur.input_descriptor_path &&
                i.verifiable_credential_path === cur.verifiable_credential_path);
            if (!result) {
                return arr.concat([cur]);
            }
            else {
                return arr;
            }
        }, []);
    }
}
exports.AbstractEvaluationHandler = AbstractEvaluationHandler;
